/* eslint-disable no-control-regex */
import React, { useContext, useEffect, useState } from 'react'
import { Buffer } from 'buffer'
import {
  Grid,
  makeStyles,
  Box,
  Container,
  createMuiTheme,
  Backdrop,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core'

import queryString from 'query-string'
import AddIcon from '@material-ui/icons/Add'
import CustomUploadIcon from './CustomUploadIcon'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import HeaderContainer from './header'
import EvaluatorContainer from './evaluator'
import { Profile } from './profile'
import UnitContainer from './unit'
import { DigitalSignature } from './digitalSignature'
import { UserContext } from '../context/context'

import {
  postReferences,
  getProfileInformation,
  updateEvaluationSubmission,
  generateEmail
} from '../api/proReference.service'
import {
  AMNButton,
  AMNFormSubmitError,
  AMNFormSubmitSuccess
} from '@amn/shared'
import { containerStyle } from '../styles/styles'
import EvaluationForm from './evaluation'
import { capitalize } from '../utils/utils'
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'
import addIon from '../images/add-blue.svg'

import withAppInsights, { appInsights, trackEvent, noticeError } from '../telemetryService'

const useStyles = makeStyles((theme) => ({
  mainComponent: {
    backgroundColor: 'transparent'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  profileComponent: {
    backgroundColor: 'transparent'
  },
  profileComponentSide: {
    backgroundColor: 'transparent'
  },
  profileComponentSideBackground: {
    border: '1px solid rgba(200,200,200,1)',
    boxShadow: '-3px 0px 5px 0px rgba(200,200,200,1)'
  },
  profileComponentSideContent: {
    marginLeft: '1px',
    backgroundColor: 'transparent',
    position: 'fixed'
  },
  container: {
    display: 'flex',
    alignItems: 'flex-start'
  },
  icon: {
    marginTop: '3px',
    width: '35px',
    height: '35px'
  },
  addReferenceButton: {
    margin: '0px 0px 10px -6px',
    [theme.breakpoints.up('sm')]: {
      margin: '0px 0px 10px 7px'
    }
  }
}))
const errorStyle = makeStyles((theme) => ({
  container: { display: 'flex', alignItems: 'flex-start', width: '616px' },
  dialogTitle: { color: '#555555' },
  button: { display: 'flex', fontWeight: 'bold', padding: '10px 30px' },
  dialogText: { display: 'flex', font: 'normal normal 300 Open Sans' }
}))
const successStyle = makeStyles((theme) => ({
  icon: { alignItems: 'center', textAlign: 'center', padding: '0 1.5% 0 1.5%' },
  dialogTitle: {
    color: '#0065A3',
    fontWeight: 'bold',
    alignItems: 'center',
    textAlign: 'center'
  },
  dialogText: {
    font: 'normal normal 18px Verdana',
    color: '#555555',
    alignItems: 'center',
    textAlign: 'center',
    padding: '2% 0 0 0 0 '
  },
  button: {
    display: 'flex',
    fontWeight: 'bold',
    textAlign: 'center',
    width: '100%',
    margin: '7% 0 5% 0'
  },
  iconButton: {
    alignItems: 'right',
    textAlign: 'right',
    color: 'red',
    width: '50px',
    height: '50px'
  },
  iconGrid: { textAlign: 'right' },
  closeButton: { width: '25px', height: '25px', color: '#D9553D' },
  shareButton: {
    backgroundColor: '#FFFFFF',
    color: '#003C69',
    border: '1px solid #003C69',
    fontWeight: 'bold',
    textAlign: 'center',
    width: '100%',
    margin: '2% 0 2% 0',
    '&:hover': {
      backgroundColor: '#F5F5F5'
    }
  }
}))

const buttonTheme = createMuiTheme({
  typography: { button: { textTransform: 'none' } }
})

const Components = (props) => {
  const classes = useStyles()
  const containerClasses = containerStyle()
  const successClasses = successStyle()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('md'))
  const [references, setReferences] = useState(props.references)
  const {
    workHistory,
    isEvaluator,
    referenceEvaluationRatingTypes,
    referenceEvaluationCategoryTypes,
    referenceAgeTypes,
    noworkHistory
  } = props
  const { user } = useContext(UserContext)
  let workHistoryID = queryString.parse(props.location.search).whid ?? -1
  let referenceID = queryString.parse(props.location.search).rid ?? -1
  let isSharedURL = queryString.parse(props.location.search).share ?? 0
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showLoader, setShowLoader] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState([false, false, false])
  const [pop, setPop] = useState(true)
  const [canSubmit, setCanSubmit] = useState(true)

  useEffect(() => {
    if (profile === null && !loading) {
      setLoading(true)
      getProfileInformation(user.tid, user).then((response) => {
        if (response.status === 200) setProfile(response.data)
        else setLoading(false)
      })
    }
  }, [user, profile, loading])

  /**
   * Update a particular reference in the list
   * @param {*} index the index you want to update
   * @param {*} data the specifc data in the reference you want to update. Only modify what you need
   */
  const updateReference = (index, data) => {
    const existingReferences = references
    if (
      existingReferences[index] !== null &&
      existingReferences[index] !== undefined
    ) {
      existingReferences[index] = {
        ...existingReferences[index],
        ...data
      }
      setReferences([...existingReferences])
    }
  }

  const errorPage = () => {
    return (
      <Backdrop className={classes.backdrop} open={noworkHistory}>
        <Typography variant='h5' style={{ color: 'white' }}>
          Invalid Work History ID
        </Typography>
      </Backdrop>
    )
  }

  const waitPage = () => {
    return (
      <Backdrop className={classes.backdrop} open={showLoader}>
        <CircularProgress color='inherit' />
      </Backdrop>
    )
  }

  const sendEmailToAll = (
    emailDataForEvaluators,
    emailDataForTraveler,
    emailDataRecruiterClinician
  ) => {
    emailDataForEvaluators = references.map((item) => {
      return {
        type: 'SendGrid',
        recipients: [
          {
            name: `${capitalize(item.supervisorFirstName)} ${capitalize(
              item.supervisorLastName
            )}`,
            emailAddress: item.email
          }
        ],
        templateId: `${process.env.REACT_APP_EMAIL_TEMPLATE_ID_CLINICIAN}`,
        nvPair: {
          subject: 'Clinician Evaluation Request',
          evaluatorFirstName: capitalize(item.supervisorFirstName),
          hpFirstName: capitalize(profile?.firstName),
          hpLastName: capitalize(profile?.lastName),
          evaluationUrl: `${process.env.REACT_APP_EMAIL_HOST_URL}/#/evl?tid=${
            user.tid
          }&whid=${workHistoryID}&rid=${item.id}&em=${Buffer.from(
            user.travelerEmail ?? ''
          ).toString('base64')}`
        }
      }
    })
    emailDataForTraveler = references.map((item) => {
      return {
        type: 'SendGrid',
        recipients: [
          {
            name: `${capitalize(profile?.firstName)} ${capitalize(
              profile?.lastName
            )}`,
            emailAddress: user.travelerEmail
          }
        ],
        templateId: `${process.env.REACT_APP_EMAIL_TEMPLATE_ID_EVALUATION}`,
        nvPair: {
          subject: 'Your Request Has Been Received',
          evaluatorFirstName: capitalize(item.supervisorFirstName),
          hpFirstName: capitalize(profile?.firstName),
          hpLastName: capitalize(profile?.lastName),
          evaluatorEmail: item.email,
          evaluationUrl: `${process.env.REACT_APP_EMAIL_HOST_URL}/#/evl?tid=${
            user.tid
          }&whid=${workHistoryID}&rid=${item.id}&em=${Buffer.from(
            user.travelerEmail ?? ''
          ).toString('base64')}`
        }
      }
    })

    profile.contacts
      .filter(
        (x) =>
          x.status === 'Active' &&
          x.type === 'Recruiter' &&
          x.eMailAddresses?.length > 0
      )
      .forEach((recruiter) => {
        references.forEach((reference) => {
          const EMAIL = {
            type: 'SendGrid',
            recipients: [
              {
                name: `${capitalize(recruiter.firstName)} ${capitalize(
                  recruiter.lastName
                )}`,
                emailAddress: recruiter.eMailAddresses[0].eMail
              }
            ],

            templateId:
              process.env.REACT_APP_EMAIL_TEMPLATE_ID_RECRUITER_NOTIFICATION,
            nvPair: {
              subject: 'Reference Requested',
              hpFirstName: capitalize(profile.firstName),
              travelerId: profile.id,
              evaluatorEmail: reference.email,
              evaluatorName: `${capitalize(
                reference.supervisorFirstName
              )} ${capitalize(reference.supervisorLastName)}`,
              evaluatorPhone: reference.supervisorPhoneNumber,
              placementId: workHistory.workHistory.placementId,
              assignmentName: workHistory.workHistory.facility,
              unit: reference.unitName,
              position: reference.positionHeld,
              dateSubmitted: moment().format('MMMM Do YYYY, h:mm:ss a')
            }
          }
          generateEmail(user, EMAIL)
        })
      })
    if (
      profile.contacts.filter(
        (x) =>
          x.status === 'Active' &&
          x.type === 'Recruiter' &&
          x.eMailAddresses?.length > 0
      ).length === 0
    ) {
      profile.brands
        .filter((x) => x.division === 'Travel' || x.division === 'Allied')
        .forEach((recruiter) => {
          references.forEach((reference) => {
            const EMAIL = {
              type: 'SendGrid',
              recipients: [
                {
                  name: `${capitalize(recruiter.name)}`,

                  emailAddress:
                    recruiter.division === 'Travel'
                      ? 'RecruitmentAdmins-DL@amnhealthcare.com'
                      : 'AlliedPassportApps-DL@amnhealthcare.com'
                }
              ],

              templateId:
                process.env.REACT_APP_EMAIL_TEMPLATE_ID_RECRUITER_NOTIFICATION,
              nvPair: {
                subject: 'Reference Requested',
                hpFirstName: capitalize(profile.firstName),
                travelerId: profile.id,
                evaluatorEmail: reference.email,
                evaluatorName: `${capitalize(
                  reference.supervisorFirstName
                )} ${capitalize(reference.supervisorLastName)}`,
                evaluatorPhone: reference.supervisorPhoneNumber,
                placementId: workHistory.workHistory.placementId,
                assignmentName: workHistory.workHistory.facility,
                unit: reference.unitName,
                position: reference.positionHeld,
                dateSubmitted: moment().format('MMMM Do YYYY, h:mm:ss a')
              }
            }
            generateEmail(user, EMAIL)
          })
        })
    }
    emailDataForEvaluators.map((data) => {
      generateEmail(user, data)
    })
    emailDataForTraveler.map((data) => {
      generateEmail(user, data)
    })
  }

  // Update a specific evaluation for the given index
  const updateEvaluation = (index, data) => {
    if (references[index] !== null && references[index] !== undefined) {
      const existingReference = references[index]
      const foundItem = existingReference.evaluations.find(
        (item) => item.categoryId === data.categoryId
      )
      if (!foundItem) existingReference.evaluations.push(data)
      else {
        existingReference.evaluations = existingReference.evaluations.map(
          (item) => {
            if (item.categoryId === data.categoryId) return data
            else return item
          }
        )
      }
      const existingReferences = references
      existingReferences[index] = existingReference
      setReferences(existingReferences)
    }
  }

  // Update all the age competencies for a given index
  const updateAgeCompetency = (index, data) => {
    if (references[index] !== null && references[index] !== undefined) {
      references[index].ageCompetencies = data
      setReferences(references)
    }
  }

  const updateError = (index, isError) => {
    const existingError = error

    existingError[index] = isError
    setError(existingError)
  }

  /**
   * Add a blank reference to the list
   */
  const addNewReference = (event) => {
    // TODO: Pro-populate any information from the previos reference, if one exists
    const existingReferences = references
    if (existingReferences.length < 3) {
      existingReferences.push({
        unitName: references[references.length - 1].unitName ?? '',
        positionHeld: references[references.length - 1].positionHeld ?? '',
        supervisorPhoneType: 6,
        amhTitleId: props.jobTitles[0].value,
        amhTitle: props.jobTitles[0].label,
        title: props.jobTitles[0].label
      })
      setReferences([...existingReferences])
      if (existingReferences.length === 2) references[1].unitDescription = ''
    } else throw Error('number of references exceeded max limit of 3')
  }

  const deleteReference = (index) => {
    const tmpReferences = []
    references.forEach((item, i) => {
      if (i !== index) tmpReferences.push(item)
    })
    setReferences([...tmpReferences])
  }

  const handlePhone = (index) => {
    let isError = false
    if (
      references[index].supervisorPhoneNumber !== null &&
      references[index].supervisorPhoneNumber?.length < 16
    )
      isError = true

    if (references[index].supervisorPhoneNumber === undefined) isError = false

    return isError
  }
  /**
   * to check for validations on submit

   */

  //to capitalize first letter of names in email input

  const handleEmail = (i) => {
    let isError

    if (
      references[i].email &&
      // eslint-disable-next-line no-useless-escape
      !/^((([a-zA-Z]|\d|[!#\$%&'\*\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(
        references[i].email
      )
    )
      isError = true
    else isError = false

    return isError
  }

  const handleValidations = () => {
    let isSuccessful = false
    for (let i = 0; i < references.length; i++) {
      if (
        references[i].unitName === undefined ||
        references[i].untiName === '' ||
        references[i].email === undefined ||
        references[i].email === '' ||
        handleEmail(i) ||
        handlePhone(i) ||
        references[i].chargeExperience === undefined ||
        references[i].chargeExperience === '' ||
        references[i].positionHeld === undefined ||
        references[i].positionHeld === '' ||
        references[i].supervisorFirstName === undefined ||
        references[i].supervisorFirstName === '' ||
        references[i].supervisorLastName === undefined ||
        references[i].supervisorLastName === '' ||
        references[i].title === undefined ||
        references[i].title === '' ||
        references[i].unitDescription === undefined ||
        references[i].unitDescription === '' ||
        (references[i].amhTitleId === 30 &&
          (!references[i].otherSupervisorTitle ||
            references[i].otherSupervisorTitle === ''))
      ) {
        updateError(i, true)
        setCanSubmit(false)
        isSuccessful = false
      } else {
        updateError(i, false)
        setCanSubmit(true)
        isSuccessful = true
      }
    }

    if (!isSuccessful) setCanSubmit(false)
    else setCanSubmit(true)

    return isSuccessful
  }

  const handleEvaluationValidations = () => {
    let isSuccessful = true

    for (let i = 0; i < references.length; i++) {
      if (
        references[i].unitName === undefined ||
        references[i].unitName === '' ||
        references[i].chargeExperience === undefined ||
        references[i].chargeExperience === '' ||
        // references[i].telemetryMonitoring === undefined ||
        // references[i].telemetryMonitoring === "" ||
        references[i].positionHeld === undefined ||
        references[i].positionHeld === '' ||
        references[i].comment === undefined ||
        references[i].comment === '' ||
        references[i].title === undefined ||
        references[i].title === '' ||
        references[i].unitDescription === undefined ||
        references[i].unitDescription === '' ||
        references[i].evaluations.length !==
          referenceEvaluationCategoryTypes.length ||
        //this doesn't work when the data is filled on resubmission of a successful
        Object.keys(references[i].ageCompetencies).length === 0
      ) {
        updateError(0, true)
        setCanSubmit(false)
        isSuccessful = false
      } else {
        updateError(0, false)
        setCanSubmit(true)
      }
    }

    if (!isSuccessful) setCanSubmit(false)
    else setCanSubmit(true)

    return isSuccessful
  }

  const handleSuccess = () => {
    setSuccess(false)
    trackEvent('Professional Reference Request - I\'m All Done')
    if (user && !user.isTSCRequest) {
      props.history.push({
        pathname: `/${!user?.isTSCRequest ? 'redirect' : ''}`
      })
    }
    if (window.parent) window.parent.postMessage({action: 'close'}, '*')
    if (user && user.isTSCRequest)
      window.location.replace('https://www.amnhealthcare.com/')
  }

  const handleShareViaText = async () => {
    try {
      // Get the first reference's evaluation URL
      const evaluationUrl = `${process.env.REACT_APP_EMAIL_HOST_URL}/#/evl?tid=${
        user.tid
      }&whid=${workHistoryID}&rid=${references[0].id}&em=${Buffer.from(
        user.travelerEmail ?? ''
      ).toString('base64')}&share=1`

      console.log('evaluationUrl:', evaluationUrl)
      trackEvent('Professional Reference Request - Share Via Text', { evaluationUrl })

      const shareData = {
        title: 'Professional References',
        url: evaluationUrl
      }

      // Check if the Web Share API is supported
      if (navigator.share) {
        await navigator.share(shareData)
        console.log('Content shared successfully')
      } else {
        // Fallback for browsers that don't support Web Share API
        if (navigator.clipboard && window.isSecureContext) {
          // Copy to clipboard if available
          await navigator.clipboard.writeText(`${shareData.url}`)
          alert('Link copied to clipboard! You can now paste it in your message.')
        } else {
          // Last fallback - show the URL in a prompt for manual copying
          prompt('Copy this link to share:', `${shareData.url}`)
        }
      }
    } catch (error) {
      console.error('Error sharing:', error)
      // If sharing fails, fallback to showing the URL
      const evaluationUrl = `${process.env.REACT_APP_EMAIL_HOST_URL}/#/evl?tid=${
        user.tid
      }&whid=${workHistoryID}&rid=${references[0].id}&em=${Buffer.from(
        user.travelerEmail ?? ''
      ).toString('base64')}&share=1`
    }
  }

  const handleCloseError = () => {
    setPop(false)
    setShowLoader(false)
  }

  const handleCancel = () => {
    if (user && !user.isTSCRequest) {
      props.history.push({
        pathname: `/${!user?.isTSCRequest ? 'cancel' : ''}`
      })
    }
    if (window.parent) window.parent.postMessage({action: 'cancel'}, '*')
  }

  const AddMoreButton = () => {
    return (
      <AMNButton
        size='large'
        className={containerClasses.referencebuttons}
        disabledElevation={false}
        color='primary'
        text='Add Reference'
        theme={buttonTheme}
        onClick={addNewReference}
      />
    )
  }

  const submitHandler = (checked) => {
    appInsights.trackEvent({
      name: 'Initial call - Submit operation for reference form',
      properties: { referenceID }
    })
    trackEvent('Initial call - Submit operation for reference form', { referenceID })
    setShowLoader(true)

    if (
      isEvaluator
        ? handleEvaluationValidations() && checked === true
        : references.length !== null &&
          handleValidations() &&
          checked === true
    ) {
      const emailDataNotification = references.map((item) => {
        let supervisorFirstName
        let supervisorLastName
        if (isEvaluator) {
          supervisorFirstName = item.supervisorName
            .split(' ')
            .slice(0, -1)
          supervisorLastName = item.supervisorName
            .split(' ')
            .slice(-1)
        }

        if (isEvaluator) {
          return {
            type: 'SendGrid',
            recipients: [
              {
                name: `${capitalize(profile?.firstName)} ${capitalize(
                  profile?.lastName
                )}`,
                emailAddress:
                  user.travelerEmail ||
                  Buffer.from(
                    queryString.parse(props.location.search).em ?? '',
                    'base64'
                  ).toString('ascii')
              }
            ],
            templateId: `${process.env.REACT_APP_EMAIL_TEMPLATE_ID_EVALUATION_NOTIFICATION}`,
            nvPair: {
              subject: 'Your Reference Has Been Received',
              hpFirstName: capitalize(profile.firstName),
              evaluatorFirstName: capitalize(...supervisorFirstName),
              evaluatorLastName: capitalize(...supervisorLastName)
            }
          }
        }
      })

      const emailDataEvaluationSubmission = references.map((item) => {
        let supervisorFirstName

        if (isEvaluator) {
          supervisorFirstName = item.supervisorName
            .split(' ')
            .slice(0, -1)
        }
        if (isEvaluator) {
          return {
            type: 'SendGrid',
            recipients: [
              {
                name: `${capitalize(item.supervisorName)}`,
                emailAddress: item.email
              }
            ],
            templateId: `${process.env.REACT_APP_EMAIL_TEMPLATE_ID_EVALUATION_COMPLETE}`,
            nvPair: {
              subject: 'Thank you for Submitting a Reference',
              evaluatorFirstName: capitalize(...supervisorFirstName),
              hpFirstName: capitalize(profile.firstName),
              hpLastName: capitalize(profile.lastName)
            }
          }
        }
      })
      const emailDataRecruiterEvaluation = profile?.contacts
        .filter(
          (x) =>
            x.status === 'Active' &&
            x.type === 'Recruiter' &&
            x.eMailAddresses?.length > 0
        )

        .map((data) => {
          return {
            type: 'SendGrid',
            recipients: [
              {
                name: capitalize(data.firstName) + ' ' + capitalize(data.lastName),
                emailAddress: data.eMailAddresses[0].eMail
              }
            ],
            templateId: process.env.REACT_APP_EMAIL_TEMPLATE_ID_RECRUITER_COMPLETION,

            nvPair: {
              subject: 'Reference Completed',
              hpFirstName: capitalize(profile.firstName),
              travelerId: profile.id,
              evaluatorEmail: references[0].email,
              evaluatorName: capitalize(references[0].supervisorName),
              evaluatorPhone: references[0].supervisorPhoneNumber,
              placementId: workHistory.workHistory.placementId,
              assignmentName: workHistory.workHistory.facility,
              unit: references[0].unitName,
              position: references[0].positionHeld,
              dateSubmitted: moment().format(
                'MMMM Do YYYY, h:mm:ss a'
              )
            }
          }
        })

      if (
        profile?.contacts.filter(
          (x) =>
            x.status === 'Active' &&
            x.type === 'Recruiter' &&
            x.eMailAddresses?.length > 0
        ).length === 0
      ) {
        profile.brands
          .filter(
            (x) => x.division === 'Travel' || x.division === 'Allied'
          )
          .forEach((recruiter) => {
            const Data = {
              type: 'SendGrid',
              recipients: [
                {
                  name: `${capitalize(recruiter.name)}`,
                  emailAddress:
                    recruiter.division === 'Travel'
                      ? 'RecruitmentAdmins-DL@amnhealthcare.com'
                      : 'AlliedPassportApps-DL@amnhealthcare.com'
                }
              ],
              templateId: `${process.env.REACT_APP_EMAIL_TEMPLATE_ID_RECRUITER_COMPLETION}`,

              nvPair: {
                subject: 'Reference Completed',
                hpFirstName: capitalize(profile.firstName),
                travelerId: profile.id,
                evaluatorEmail: references[0].email,
                evaluatorName: `${capitalize(
                  references[0].supervisorName
                )}`,
                evaluatorPhone: references[0].supervisorPhoneNumber,
                placementId: workHistory.workHistory.placementId,
                assignmentName: workHistory.workHistory.facility,
                unit: references[0].unitName,
                position: references[0].positionHeld,
                dateSubmitted: moment().format(
                  'MMMM Do YYYY, h:mm:ss a'
                )
              }
            }
            generateEmail(user, Data)
          })
      }

      const data = references.map((item) => {
        if (!isEvaluator) {
          return {
            ...item,
            referenceTypeId: 8,
            contactPreferenceTypeId: 1,
            statusId: 9,
            status: null,
            changedDate: '2020-09-22T00:00:00',

            amhTitleId: props.jobTitles.filter(
              (jobTitle) => jobTitle.label === item.title
            )[0].value,
            title:
              item.amhTitleId !== 30
                ? item.amhTitle
                : item.otherSupervisorTitle,
            amhTitle: item.amhTitle,
            evaluatorPhones: [
              {
                typeId: item.supervisorPhoneType,
                type: item.supervisorPhoneName,
                phoneNumber: item.supervisorPhoneNumber ?? ' '
              }
            ],
            supervisorName: `${item.supervisorFirstName} ${item.supervisorLastName}`
          }
        } else {
          return {
            ...item,
            statusId: 10,
            id: item.id,
            changedDate: '2020-09-22T00:00:00',
            amhTitleId: parseInt(
              props.jobTitles.filter(
                (jobTitle) => jobTitle.label === item.amhTitle
              )[0].value
            ),
            title:
              item.amhTitleId !== 30
                ? item.amhTitle
                : item.otherSupervisorTitle ?? item.title,
            amhTitle: item.title,
            ageCompetencies: item.ageCompetencies,
            chargeExperience: item.chargeExperience,
            comment: item.comment,
            eligibleForRehire: item.eligibleForRehire,
            evaluations: item.evaluations,
            //   telemetryMonitoring: item.telemetryMonitoring,
            unitName: item.unitName,
            unitDescription: item.unitDescription,
            positionHeld: item.positionHeld
          }
        }
      })

      !isEvaluator
        ? postReferences(user.tid, workHistoryID, user, data).then(
          (response) => {
            if (response.status >= 201 && response.status <= 204) {
              response.data.map((res, i) =>
                updateReference(i, { id: res.id })
              )

              setSuccess(true)
              setCanSubmit(true)
              setShowLoader(false)

              sendEmailToAll()
              trackEvent('Submit operation for reference form', { response })
            } else {
              setSuccess(false)
              setCanSubmit(false)
              setPop(true)
              setShowLoader(false)
              noticeError('Submit operation for reference form error', { response })
            }
          }
        )
        : updateEvaluationSubmission(
          user.tid,
          workHistoryID,
          referenceID,
          user,
          data[0]
        ).then((response) => {
          appInsights.trackEvent({
            name: 'Submit operation for evaluation reference form',
            properties: { response }
          })
          if (response.status >= 201 && response.status <= 204) {
            setSuccess(true)
            setCanSubmit(true)
            setShowLoader(false)
            generateEmail(user, ...emailDataNotification)
            generateEmail(user, ...emailDataEvaluationSubmission)
            generateEmail(user, ...emailDataRecruiterEvaluation)
            if (isSharedURL === '1') {
              trackEvent('Submit operation for evaluation reference form - Shared URL', { response })
            }
            else {
              trackEvent('Submit operation for evaluation reference form', { response })
            }
          } else {
            setSuccess(false)
            setCanSubmit(false)
            setPop(true)
            setShowLoader(false)
            noticeError('Submit operation for evaluation form error', { response })
          }
        })
    } else setCanSubmit(false)

    setPop(true)
    setLoading(false)
  }

  return noworkHistory ? (
    errorPage()
  ) : (
    <Grid container>
      {waitPage()}
      <Grid item xs={false} sm={1} md={1} />
      <Grid
        className={classes.mainComponent}
        item
        xs={12}
        sm={10}
        md={7}
        lg={8}
      >
        <Grid item xs={12} md={11} lg={10}>
          <HeaderContainer isEvaluator={isEvaluator} profile={profile} />
        </Grid>
        {!matches && (
          <Grid className={classes.profileComponent} item xs={12} md={12}>
            <Profile
              workHistory={workHistory}
              profile={profile}
              tid={user.tid}
            />
          </Grid>
        )}
        <Grid item xs={12} md={11} lg={10}>
          <Container>
            <Container
              style={{
                backgroundColor: 'white',
                border: '1px solid lightgrey'
              }}
            >
              {references.map((reference, index) => {
                return (
                  <div key={index}>
                    <div
                      className={
                        index > 0 ? containerClasses.separationBorder : null
                      }
                    >
                      {index > 0 ? (
                        <Container
                          disableGutters
                          className={containerClasses.secondReferenceRoot}
                          style={{ marginTop: '20px' }}
                        >
                          <Grid container alignItems='center' alignContent='center'>
                            <Grid xs={6} item>
                              <Typography variant='h6'>
                                {`Reference ${index + 1}`}
                              </Typography>
                            </Grid>
                            <Grid
                              xs={6}
                              item
                              style={{
                                display: 'flex',
                                justifyContent: 'flex-end'
                              }}
                            >
                              <AMNButton
                                size='large'
                                className={
                                  containerClasses.deleteReferenceButton
                                }
                                disabaledElevation={false}
                                color='primary'
                                text='delete reference'
                                theme={buttonTheme}
                                onClick={() => {
                                  deleteReference(index)
                                }}
                              />
                            </Grid>
                          </Grid>
                        </Container>
                      ) : (
                        ''
                      )}
                      <EvaluatorContainer
                        phoneTypes={props.phoneTypes}
                        reference={reference}
                        workHistory={workHistory.workHistory}
                        isEvaluator={isEvaluator}
                        handleEmail={handleEmail}
                        index={index}
                        jobTitles={props.jobTitles}
                        updateReference={updateReference}
                        error={error[index]}
                      />
                      <UnitContainer
                        reference={reference}
                        workHistory={workHistory.workHistory}
                        isEvaluator={isEvaluator}
                        index={index}
                        updateReference={updateReference}
                        error={error[index]}
                      />
                    </div>
                  </div>
                )
              })}
            </Container>

            <div style={{ marginTop: '2%' }}>
              {isEvaluator ? (
                <EvaluationForm
                  updateReference={updateReference}
                  updateEvaluation={updateEvaluation}
                  reference={references[0]}
                  updateAgeCompetency={updateAgeCompetency}
                  referenceEvaluationRatingTypes={referenceEvaluationRatingTypes}
                  referenceEvaluationCategoryTypes={referenceEvaluationCategoryTypes}
                  referenceAgeTypes={referenceAgeTypes}
                  error={error[0]}
                />
              ) : null}
            </div>
          </Container>
          <DigitalSignature
            isEvaluator={isEvaluator}
            onCancel={(signed) => {
              handleCancel()
            }}
            onSubmit={submitHandler}
          />
        </Grid>
      </Grid>
      {matches && (
        <Box className={classes.profileComponentSideBackground}>
          <Grid item className={classes.profileComponentSide} md={4} lg={3}>
            <div className={classes.profileComponentSideContent}>
              <Profile
                workHistory={workHistory}
                profile={profile}
                tid={user.tid}
              />
            </div>
          </Grid>
        </Box>
      )}
      <Grid item xs={false} sm={1} md={2} /> {/* Space */}
      <Dialog
        open={success}
        fullScreen={!!isEvaluator}
        onClose={handleSuccess}
        maxWidth='sm'
        fullWidth
      >
        <DialogTitle className={successClasses.dialogTitle}>
          <div style={{ textAlign: 'center', margin: '30px auto 20px auto' }}>
            <img
              src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAA5CAYAAACWJGMLAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAANaADAAQAAAABAAAAOQAAAAABQcDLAAAGHklEQVRoBe2aS1YiSxCGG73HdiY7kF6B9grEFTR3BeLEx0hcAbAC6JGPCfQKGlcArEBcgbADHepA+vurI+smhQWNVYX0ueY5SUZFZkbEnxEZlVVF7tOccnl5OcjlctsvLy9fT09Ph3OGr0T3P7OsuLi4KANoR2PW1tZqNGXqUotsQPc37KhL8Xg8rrLANyxwO86QtbiOVquVR1DV6z9AQdG7XgoJoDKKSoDpqoo2Xqz+WFDPz88VQBVs5khtBKR1Zdugs4KGR2re6qPxYhW/CkpeYsaZzfqBu8uiEVa8uroqGX+ZzdhT5tMe+z9yCpQA4aUWQwTscWNjo0L89qD7VMV0Y5lhyILWUBvYQht4DBua0LElTBQG5kxhx2gJUWkeHh4+iJBwYrmLtwrULlmxjfB61hkRXT3U79KWZAc6OzQ90XElpw7LMA1IB0Yr0jw+Pq7RhsVCrwljO2QyDm/WHXiP/25kDkN7aN9zFrAS3z9//lybZaQtgsBt2bwHPLky9zHtqYIZJtcOcfPtLEA2dsjYWzePNr++vu687LHfh8zZXtKqH3gmDFj5c0sQIRsPaT9VqeWQSQLRfouO9fqXTgZ7SlplMImgDRmGIsYeYqx4rl/ecR4ZQVfYdx31r1IJQTmjAFfEE03qjsKR/fVV4cjeazNG3nwErNK8rleyTIGSlea1e7O4DsCOt4fO8Y7CdWXLq6BkreeZBwANAFaEPQJQgXaly9SJwlmrkwR0cAc3QMEN2PWvchvrKRmNt2o0VdGUPl4qBlTCH8u4XcT0kHmeUNzU9PCYNNUDA2817di0pbT92phFeCySHiEayOwzb1cVnqJBz0uHR0dHg0XkxY2NDT9NUNYDWAFAX1K6D+kMV0C0sqgrioRdwBYdI2k701MSbqeLh6SKbL48IVn5iDwlo/sI782XMz31ZqmvTCTMKrB/UqOANDqPBzs2RteJytJAYeWQqv0TV3RTH8R1LsKfmf0WEfQnY3Va0TPZa2MBtJ/Svv20TE8JS0E/7J87tSoeXQgYKfwsFZTOi/KI9zZodHJyooyoZ7F2CnjeV4TOl7oJv68VH9o/VuBjBf63K5D5zdd9CiJt76d1Cp/nrUzvUzrLAWYHI/LcnxrzjEmrPzNP2YOgTt7hvSjNo9CsBcjMU/47eXcUwmutWcak1ZcJKJ0WMPDMjKwDqiIaUAX6ysbPrEkdlABxtnPPTfoU1NTpG2A3QkFfg71WygwRglPbUwKDJ6KvpMN3hAY2fLoFpIDqU1AvbYCJQVlCUKgpxFxSGJEU9H697Rt8fX2tdxFNeHsev8NYvbcferxEZGJQdh/aMSv0ZDv1XStqIV7Tw2Ib/rb1pfopaGJPKdaptygtm7JFmzETxvMeKQCUx2Ma60rixXWC1E6A4npXFaVl2j8qfEAoMrBOlZcUfrWnp6dbFucAeqLIQ3i2C/OnMqF16kP5burhZ5v4gMXTF48i7ZC2jdI73qB2TPnMRt4BTI152l+u1Jlf04XpuHcdtJl91wrczup1MOabpzAkMSoYEzLmEGZ8m2F7VL0M/aJ3h54OvTUqJcl6RIGOX724s2QQfnhG3uhTR1QVhVIf/vfgaoEfhRFASiZDf1+oKOzcogFI37Z6C4icGAqgGowGtnXj9u6EF2xClUmJPwZ4smTUgKp0fqcXLWK8pQgEi6QQztv8MLx9edFEIeUKj7Y/6C20ThKSZXMDIICqvEWWmwMgycy7a9qqwt27DsgJT0U7k16jsEwmbZmcRN73ZWlbEM5l5G5B62Sib9ND05PeMckJjLZ2cy5gRDFuY0fn+Ne2H1vMLxh/RPIqKFlw3TCemvBPKpl6ylP4JhLD20w8cJPxyA1ViWYonnlPIbmla8oD4Peje+p31+r8lpwpgBlSmw6Q+Jubmx0aF95i6aRSXGlQClkM7ctahR/7U3/0CkDocGyZUGGooqSkbNhc6fALTOXH9lUTYDvikZ31Pr4GuadrSl3Z1j4QZp8ofutM55c9NkTStkJRnoNW+RfvKAzDstLhF1ppBB4qi/QA6TYxAUj9fxUoO14Fe0zGA7KmNlr+KlAyHi8pMSgp/DCQYk+UX7TGyqHPI3qKAAAAAElFTkSuQmCC'
              alt='shine-icon'
              style={{ width: 53, height: 57, padding: '0 1.5%' }}
            />
            <img
              src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABNCAYAAADjCemwAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAATaADAAQAAAABAAAATQAAAACPtwcpAAAIJUlEQVR4AeWcW3ITRxSGu2W/JKYKdoCygojHBCiUFcAOrKwAiQ1gNiA5K0BZAWYFKIUcHjEriNgBqTI8GXf+v0dtaUbTp3ukuck5VVLPTF/Pp9P3HmnVlEzOe8qo+0qrnlLX+Oh7y6L000UyX+B3sXwGV39RRs+U/uGTGj2AX/2ia8ty8vGeMl+fAlIfefLTxWdXWSCBGeAD4tHbuiBWD208P1baPIOF4FO50BL/UKOH0ypzOqwkcVqV+vYc1W6I9HFd/W9j9TDqJ2QFcNVKudqkYN20UdVq4FI36l+ldR9WtkfQJn8/U+r7a1gVLKtmqREYNdvd0iYfugks27jXTAvZ1QyMCu4GrWzrMuavfOq6h5Le3fBrANhu0CbzCRIYbigS+4CANIYKHDKow4Ua/bLAtSzWqk0Pls0xXl/pzrCONixbqOKWZhv7S7ZdaMMKilFv0VifKfXjWV1jqoIljApeDJoF9vUdUsavXUCM+lPpg5MoayqQbKlBE93ewBhGIeuNh7YNMIOBpu6cthoWyad047St85sELg5aKtGI39eoT6iGAynjiFTqCZKrmwyuE1cytmGxVdK8Ui8e9fYXGIlwrHn9TnFRIUfCljY+P8XcEVOigNjuH3PM0eNZIGQ7vHMtLFu0fIuTLY3jsGhgnMLcJmAECIsz16dZlP4Jux0TXXFokY2Tvrft1xGANbO2lS5MxF2UhS3TsbrdeZZNVbC0iHmkrZK3GVi+bvnQ7PRI9bOEU/c3U5jbamH5wMhgs+5Z8738J+lBUpgyNwZjmdvWhkHFiOYmx9IuhxHAXv1fgdFy0pYWY2X8JTgO2wcp3Oj7q+S6uhlLi7AyjvT3QSoCRtUz0JQ8iOVcsobl5J1/kwqBpaFNzgfBtoyT77ZLxcDS0AymQJJweSdmoVBKo2q/GoBRhaR6MjOtnoo6cT2szVITMCJYtmnfQlaG3euI5eimoNYIbAXNmL6or12iFkM051kzMCqaWJo2ctXkmn4bpQFgCTS70MZFN49w16iNKxgNAUugKd3lhVeSbTavt9eDW3yelU9vnFiPBoGxiKie2EOUZSZ75/hO5lweH0pLxjmx4h41DIyF7OCAXAAaNnKLSAJskESR19qLJGvDtgAYywFLM/72jCGKDDVSwBiZUhK4lgCjRstxGi9zxHu2IidsLjAXbkdwLQJGjTrYn3ziVNvatfNWNZDjbwmuZcCoo2xpMoWV7wjHNTk3DUpBcC0ERhX9u1FBAJkALx4N1HjOZc3jjE/m9gYclssfXmQ8V7dNAktqzv1VYVJXn8uDxnTLAtckMMvHvITTtZfZL7Tz5VTP9YQJbpeq2jgwq0x3XaXsNcZpvtOHCKr13WyEqPttwbUDWFDFkKUFBr5C+oXBve8rFXn2LWKbTSiZ7GVPFkhB9ALQ9EIKooKJCLELgdPvkFL4R6oSmFXlqitoBFwG0PAlBlI847qDRIOLyKNyYLYMfbkkBxewtAN/t8/YoQVKOYfEtwxw9QCDvqG5OC1t9YZbvvraPMn3KPh0F3B1AaNKIX0xtuzYCblRnwUEveRMqhAi1msbcHUCi1mQha6u95zJegc2XuTIad8i4OoExlKawPx5uVeSQNN46VSUiOOjYvyMZwy4uoGxiPr6OFPSzG3CaWlpwY0TVNEP3UwKu91K4JoAZuebnBd7hE3Ycq6cQOPGSWjqY76feJLb/nEeuCaAWQ2MbGXaTJ2irk2DaXbO3MNcl6sXZVsbM1oH1xSwCWcjih9BDqfOcwVt9OsZrE3qRRHnauIiluoSnML7BzrufFipedvEtKyX3cZcnTDQqQLYem1ep55t3OzRsdGNsuc8mMyHeCpDU2md09CY5nj+BQuJ0urGQqmjB63cQGb5i4htbq4+om0SOgCsAr143F9PdlU93VNtTt2lx+1iNSLwy3hitu7x9zciMJZXq5NssTctjSHG8wUC388GTt/r39EFT9PP9uhu8v4ERF6KJWZblrEyht+0ND7VZkBHFrR9VR07kDPe3TcZk8nAmIs+HORllg+N7wfwLeCg+N9UC0ZtKsCE/+oQ6uxYOPTmno3yfGiMo48G4SHIzc5Sj1FaLxYYX18KCMeLo8cnvlB+aJwl6Jj31PcEnK2S1+GG376+dABr9IsfGuMkc62RP7rzITjzUY3fP3dPWuVOztF+xVRJlFp3Br5q6XTK7z2dr3PH8yl602N3K7vmTKk76Flb8KKZHYdxWKEim4+4EYFsaY7O+vzQPfO6rNJ4Ic22H95A1XtYq+fANRKYPfIfN4SKszSn4nh+AYv72d1GuLOkF6rxbT07+bZzyUjrghYEZue/ERohSDFoTLNQVb0pxKxyePZ/2uzKa/8m15iLgsCYZHFojLUdOMZcIMspXLyXIBx+QYAosYNrroNxMM7OqKjEtWHZVLeDxlSiVgey2aXuF7ibYYvwwm4jao2V0dXySyokb9ioG4P/kOQ7D/wPSQV3G1CIaYcVHfSSWA7bQraHxsz4Sxv0lsF5auGSLRCDn+7yA6cksQudB/grDOEHCmS1GzQmzkMr5tsJLKCdY7QUAE6N/CP9VFDhZndoLnH2WkafwuqK9K4udrUuVys4+d7ButYLWB40lyqnK8bA8kJLSy5Cha6FhfWwkv+goHxojkECb9iI5VUEy6lWHTSXg+0sOH7CsEBeRncxtnO5KWS32Q6nZVVDX0Gqh7aes9sqs39NWMJRfGtRGsMGPStl3LdeVuG6XmjZgliIB/eS/3jkESfp7Rm9gCUtkqNhcMsYHGfLE3n/H/V7g9rvA3keAAAAAElFTkSuQmCC'
              alt='tick-icon'
              style={{ width: 77, height: 77, padding: '0 1.5%' }}
            />
            <img
              src='data:image/png;base64,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'
              alt='shine-icon'
              style={{ width: 53, height: 57, padding: '0 1.5%' }}
            />
          </div>
          Success
        </DialogTitle>
        <DialogContent>
          {isEvaluator ? (
            <Typography className={successClasses.dialogText}>
              Thank you for your submission! Your reference has been submitted.
            </Typography>
          ) : (
            <Typography className={successClasses.dialogText}>
              If you provided an email, a evaluation request link is on its way to your evaluator. For a faster response, or if you only added a phone number, send a link to them by text.
            </Typography>
          )}
        </DialogContent>
        <DialogActions style={{ flexDirection: 'column', padding: '0 24px 24px 24px' }}>
          {!isEvaluator && (
            <>
              <Button
                variant='outlined'
                color=''
                className={successClasses.shareButton}
                startIcon={<CustomUploadIcon color='#003C69' style={{ width: 30, height: 30 }} />}
                onClick={handleShareViaText}
              >
                SHARE VIA TEXT
              </Button>
              <Typography
                variant='body2'
                style={{
                  color: '#666666',
                  textAlign: 'center',
                  margin: '10px',
                  fontSize: '16px'
                }}
              >
                This link is just for them. Please don't share it with anyone else.
              </Typography>
            </>
          )}
          <Box
            style={{
              width: '100%',
              height: '1px',
              backgroundColor: '#E0E0E0',
              margin: '16px 0'
            }}
          />
          <Button
            variant='contained'
            color='primary'
            className={successClasses.button}
            style={{
              marginTop: '8px'
            }}
            onClick={handleSuccess}
          >
            I'M ALL DONE
          </Button>
        </DialogActions>
      </Dialog>
      <AMNFormSubmitError
        open={!canSubmit && pop}
        buttonText='Dismiss'
        dialogText='You need to fill out all of the required fields on this page before you can continue.'
        dialogTitle="Can't Continue"
        handleClose={handleCloseError}
        variant='text'
        color='primary'
        userStyle={errorStyle}
      />
    </Grid>
  )
}

export default Components
